<template>
  <!-- <v-card color="rgba(150, 150, 150, 0.2)"> -->
    <v-container class="text-xs-center">
      <v-layout row justify-center class="pt-5">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/JURPHEIi9U4" title="HOPESudbury telethon video 2022" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </v-layout>
      <v-layout row justify-center class="pt-5">
          <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/UHDsSy3rRic" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </v-layout>
      <v-layout row justify-center class="pt-5">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/GamRhktjpZ8" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </v-layout>

      <v-layout justify-center row wrap class="pt-5">

        <v-flex xs12 sm6 md-4 lg-2>
          <!-- <h3 class="display-3">Follow</h3> -->
          <p class="display-1">
            Add us on social media!
          </p>
          <v-btn
            color="primary"
            icon
            target="_blank"
            href= "https://www.facebook.com/VikingAMA/"
          >
            <v-icon>mdi-facebook</v-icon>
          </v-btn>
          <v-btn
            color="primary"
            icon
            target="_blank"
            href= "https://www.instagram.com/vikingadaptivema"
          >
            <v-icon>mdi-instagram</v-icon>
          </v-btn>
          <v-btn
            color="primary"
            icon
            target="_blank"
            href= "https://www.youtube.com/channel/UCkyk8mb4Z9GsXQEXGYSlESQ"
          >
            <v-icon>mdi-youtube</v-icon>
          </v-btn>

        </v-flex>
      </v-layout>

    </v-container>
  <!-- </v-card> -->
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style scoped>

p {
  margin-top: 16px;
}
h3 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/videos.vue